import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getCatalogMunicipalities = async ({ commit }, params = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/municipalities${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogMunicipality = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/municipalities/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getFederalEntitiesForMunicipalities = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/federal-entities/dropdown`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
